import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { PasswordResetRequestRequest } from '../../../requests/Auth/PasswordResetRequestRequest';
import { successToast } from '../../../../../components/Toast/successToast';
import { errorToast } from '../../../../../components/Toast/errorToast';

type Props = {
	onSuccess: () => void;
	onError: (error: AxiosError) => void;
};

export const useRequestPasswordResetMutation = ({
	onError,
	onSuccess,
}: Props) => {
	return useMutation(
		({ email, captchaToken }: { email: string; captchaToken: string | null }) =>
			PasswordResetRequestRequest({ email, captchaToken }),
		{
			onSuccess: () => {
				onSuccess();
				successToast();
			},
			onError: (error: AxiosError) => {
				errorToast();
				onError(error);
			},
		},
	);
};
